/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-extraneous-dependencies */
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { client } from "./api-client";

export const useGetSplitRouteRequests = (data: any) =>
  useQuery({
    queryKey: [
      "GetSplitRouteRequests",
      data?.pageNumber,
      data?.searchCriteria,
      data?.operationDate,
      data?.cashCenterId,
    ],
    queryFn: ({ signal }) =>
      client(`daily/operations/open/splitroute/requests`, { data, signal }),
  });

export const useCancelSplitRouteRequest = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (requestId: string) =>
      client(`daily/operations/cancel/splitroute/request/${requestId}`, {
        successMessage: "SplitRoute request cancelled successfully!",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GetSplitRouteRequests"] });
    },
  });
};

export const useCreateSplitRouteRequest = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`daily/operations/create/splitroute/request`, {
        data,
        successMessage: "SplitRoute request created successfully!",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GetSplitRouteRequests"] });
    },
  });
};

export const useGetSplitRouteJobs = ({ methodType, ...data }: any) =>
  useQuery({
    queryKey: [
      "getSplitRouteJobs",
      data?.cashCenterId,
      data?.operationDate,
      data?.routeNo,
      methodType,
    ],
    queryFn: ({ signal }) =>
      client(`daily/operations/get/splitroute/jobs`, { signal, data }),
    enabled:
      Boolean(data?.cashCenterId) &&
      Boolean(data?.operationDate) &&
      (methodType === "Sending" || Boolean(data?.routeNo)),
  });

export const useDownloadSplitRouteReceipt = () =>
  useMutation({
    mutationFn: (data: any) =>
      client(`field/operations/splitroute/received/consignments`, { data }),
  });

export const useGetSplitRouteIncomingOrders = (data: any) =>
  useQuery<any>({
    queryKey: [
      "splitRouteIncomingOrders",
      data?.cashCenterId,
      data?.operationDate,
      data?.shift,
      data?.routeNo,
    ],
    queryFn: () =>
      client(`field/operations/splitroute/incoming/boxes`, { data }),
    enabled:
      Boolean(data?.routeNo) &&
      Boolean(data?.cashCenterId) &&
      Boolean(data?.operationDate),
  });

export const useSplitRouteRecordDiscrepancy = () =>
  useMutation<any, unknown, any>({
    mutationFn: (data: any) =>
      client(`field/operations/splitroute/record/discrepancy`, { data }),
  });

export const useConfirmSplitRouteReceipt = () =>
  useMutation({
    mutationFn: (data: any) =>
      client(`field/operations/verify/splitroute/jobs`, {
        data,
        successMessage: "Split Route Receipt successfully!",
      }),
  });

export const useGetDispatchOrders = (data: any) =>
  useQuery<{
    sealedPackages: any[];
    coinsBoxes: any[];
    requests?: any[];
    shift: string;
    routeNo: string;
    teamLeaderName: string;
    teamLeaderId: string;
  }>({
    queryKey: [
      "GetDispatchOrders",
      data?.cashCenterId,
      data?.routeNo,
      data?.shift,
      data?.operationDate,
      data?.fieldTeamCashCenterId,
    ],
    queryFn: () =>
      client(`field/operations/split/route/consignments`, { data }),
    enabled:
      Boolean(data?.routeNo) &&
      Boolean(data?.cashCenterId) &&
      Boolean(data?.fieldTeamCashCenterId) &&
      Boolean(data?.operationDate),
  });

export const useConfirmDispatchOrders = () =>
  useMutation<any, Error, any>({
    mutationFn: (data: any) =>
      client(`field/operations/validate/splitroute/consignments/discrepancy`, {
        data,
        successMessage: "Discrepancy save successfully!",
      }),
  });
export const useSwapRostersTeam = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`daily/operations/rosters/swap/team/members`, {
        data,
        successMessage: "Team swapped successfully!",
      }),
    ...{
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["swapRouteTeam"] });
      },
    },
  });
};

export const useDownloadSplitDispatchDiscrepancy = () =>
  useMutation<any, unknown, any>({
    mutationFn: (data: any) =>
      client(`field/operations/download/splitroute/discrepancy`, { data }),
  });
